const TASK_BACKLOG_FILTER = {
  BACKLOG: {
    label: 'Backlog',
    value: 'BACKLOG',
  },
  NOT_BACKLOG: {
    label: 'Not Backlog',
    value: 'NOT_BACKLOG',
  },
}

export default TASK_BACKLOG_FILTER
